// extracted by mini-css-extract-plugin
export default {"root":"GCzA3q","content":"TnW2VG","templatesSection":"cDR5GV"};